import { useModal } from '#app/components/Modals/V2/GlobalModalSystem/useModal.js';
import { Text } from '#app/components/Primitives/Text.js';
import { InfoIcon } from '@contra/icons/icons';
import { css, styled, useTheme } from 'styled-components';

const Button = styled.button<{ $readonly: boolean }>`
  ${({ $readonly }) => css`
    height: 24px;
    border-radius: 25px;

    padding: 6px;
    display: flex;
    align-items: center;

    background-color: rgba(205, 116, 221, 0.12);
    transition: all 250ms ease;
    cursor: default;

    ${!$readonly &&
    css`
      cursor: pointer;
      &:hover {
        background-color: rgba(205, 116, 221, 0.25);
      }
    `}

    svg {
      flex-shrink: 0;
      display: flex;
    }
  `}
`;

const StyledText = styled(Text)`
  color: rgba(174, 48, 197, 1);
  margin-right: 4px;
  padding-top: 2px;
`;
export const IncompleteProfileButton = ({
  iconOnly = false,
  readonly = false,
  showIcon = true,
}: {
  readonly iconOnly?: boolean;
  readonly readonly?: boolean;
  readonly showIcon?: boolean;
}) => {
  const theme = useTheme();
  const { openModal } = useModal({
    identifier: 'IncompleteProfileModal',
    modalProps: {},
  });

  return (
    <Button
      $readonly={readonly}
      disabled={readonly}
      onClick={() => openModal()}
    >
      {iconOnly ? null : (
        <StyledText textStyle="captionBold">INCOMPLETE</StyledText>
      )}
      {showIcon || iconOnly ? (
        <InfoIcon
          color={theme.colorsV2.brandPink}
          size={12}
        />
      ) : undefined}
    </Button>
  );
};
